import React, { useEffect, useState } from "react";
import DashboardLayout from "./common/DashboardApp";
import ProgressBar from "../jobseeker/dashboard/ProgressBar";
import Loader from "./common/Loader";
import {
  getProgressData,
  getDashboardData,
  getProfileData,
} from "../../service/api";
import TermsModal from "./dashboard/TermsModal";

const JobseekerDashboard = () => {
  const [progressData, setProgressData] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [progress, dashboard, profile] = await Promise.all([
          getProgressData(),
          getDashboardData(),
          getProfileData(),
        ]);

        setProgressData(progress);
        setDashboardData(dashboard);
        setProfileData(profile);

      if (dashboard?.data?.termCondition === false) {
        setShowTerms(true);
      } else {
        setShowTerms(false);
      }

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   // const accepted = localStorage.getItem("termsAccepted");
  //   // if (!accepted) {
  //   //   setShowTerms(true);
  //   // }
  //   setShowTerms(true);
  // }, []);

  const handleAcceptTerms = () => {
    localStorage.setItem("termsAccepted", "true");
    setShowTerms(false);
  };

  // return profileData.data;
  if (loading) return <Loader />;

  return (
    <DashboardLayout>
      {showTerms && <TermsModal onAccept={handleAcceptTerms} />}

      <div className="panelMainWrapper">
        <div className="panelCard">
          {/* Progress popup */}
          <ProgressBar progressData={progressData} />

          <div className="row align-item-center g-0">
            <div className="col-md-7 g-0">
              <div className="profileShortInfo">
                <h4>
                  Welcome Back, <span>{profileData?.data?.name || "User"}</span>
                </h4>
                {/* <p>{profileData?.data?.email || "No email found"}</p> */}
              </div>
            </div>

            <div className="col-md-5 g-0">
              <div className="profileDashCard">
                <div className="profiledashDP">
                  <div
                    className="avatar rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundImage: `url(${
                        profileData?.data?.image ||
                        "/assets/img/default-avatar.png"
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
                <div className="profileDashContent">
                  <h5>+91 {profileData?.data?.phoneNumber || "xxxxx xxxxx"}</h5>
                  <p>{profileData?.data?.email || "user@example.com"}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div className="row align-item-center mt-4">
              <div className="col-md-4 mb-2">
                <div className="dashboard-card">
                  <i className="fa-regular fa-clock"></i>
                  <div>
                    <h4>{dashboardData?.data?.HoursWorked}</h4>
                    <p>Hours Worked</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="dashboard-card">
                  <i className="fa-solid fa-indian-rupee-sign"></i>
                  <div>
                    <h4>{dashboardData?.data?.totalEarnings}</h4>
                    <p>Total Earning</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="dashboard-card">
                  <i className="fa-solid fa-briefcase"></i>
                  <div>
                    <h4>{dashboardData?.data?.CompletedJobs}</h4>
                    <p>Jobs Completed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard raw data (optional) */}
          {/* <pre>{JSON.stringify(dashboardData, null, 2)}</pre> */}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default JobseekerDashboard;
